import { isArray } from "lodash";

export const array = (value) => {
  return isArray(value);
}